import './fonts/fonts.css'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { Box } from '@mui/system'
import store from './redux/store'
import theme from './CustomTheme'
import Routes from './routes'
import RTL from './components/Layout/RtlStyling'

const App = () => (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <Router>
          <RTL>
            <Box sx={{ fontFamily: 'Avenir' }}>
              <Routes />
            </Box>
            </RTL>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
)

export default App
